import "@/App.css";
import { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ThankYouPage } from "./pages/ThankYouPage";
import { FastListaPage } from "./pages/FastListaPage";

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallHint, setShowInstallHint] = useState(false);

  const isMobile = useMemo(() => {
    const ua = (navigator.userAgent || "").toLowerCase();
    return /android|iphone|ipad|ipod|mobile/i.test(ua);
  }, []);

  useEffect(() => {
    if (!isMobile) return;
    if (window.matchMedia("(display-mode: standalone)").matches) return;
    if (localStorage.getItem("lead_legale_install_hint_dismissed") === "1") return;

    const handler = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setShowInstallHint(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    // iOS Safari does not fire beforeinstallprompt.
    const timer = window.setTimeout(() => setShowInstallHint(true), 1200);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.clearTimeout(timer);
    };
  }, [isMobile]);

  const dismissInstallHint = () => {
    localStorage.setItem("lead_legale_install_hint_dismissed", "1");
    setShowInstallHint(false);
  };

  const handleInstall = async () => {
    if (!deferredPrompt) return dismissInstallHint();
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    dismissInstallHint();
    setDeferredPrompt(null);
  };

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/lista"
            element={(
              <ProtectedRoute>
                <FastListaPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
        </Routes>
        {showInstallHint && (
          <div
            style={{
              position: "fixed",
              left: "12px",
              right: "12px",
              bottom: "14px",
              zIndex: 1000,
              background: "rgba(10,25,47,0.95)",
              border: "1px solid rgba(212,175,55,0.35)",
              borderRadius: "10px",
              padding: "10px 12px",
              color: "#F8F9FA",
              fontSize: "13px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <span>
              Aggiungi Lead Legale alla tua Home per un accesso rapido.
            </span>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                onClick={dismissInstallHint}
                style={{
                  background: "transparent",
                  color: "#A0ABC0",
                  border: "none",
                  fontSize: "12px",
                }}
              >
                Chiudi
              </button>
              <button
                onClick={handleInstall}
                style={{
                  background: "#D4AF37",
                  color: "#0A192F",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: 600,
                  padding: "6px 10px",
                  fontSize: "12px",
                }}
              >
                Installa
              </button>
            </div>
          </div>
        )}
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
